var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    { attrs: { "body-class": _vm.loading ? "" : "p-0" } },
    [
      _vm.loading || _vm.GET_REPORTS_HISTORY_LOADING_STATE
        ? _c("report-history-loader")
        : _c("v-server-table", {
            ref: "tableRef",
            staticClass:
              "vue-custom-table no-pagination vue-custom-table-infinite",
            attrs: {
              columns: _vm.tableOptions.columns,
              options: _vm.tableOptions.options,
            },
            on: {
              loading: function ($event) {
                _vm.fetchingTableData = true
              },
              loaded: function ($event) {
                _vm.fetchingTableData = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "h__fullName",
                fn: function () {
                  return [
                    _c("div", { staticClass: "dropdown-filters-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tables.columns.fullName")) +
                              "\n          "
                          ),
                          _c("icon", { attrs: { name: "filter" } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _vm.loadingAgents
                            ? _c("inline-loader", {
                                staticClass: "d-flex justify-content-center",
                              })
                            : _c("generic-filter-dropdown-menu", {
                                attrs: {
                                  "allow-search": "",
                                  "search-placeholder":
                                    _vm.$t("agents.searchFor"),
                                  "show-all-option": "",
                                  options: _vm.agentOptions,
                                  "id-key": "agents",
                                },
                                model: {
                                  value: _vm.agentFilterState,
                                  callback: function ($$v) {
                                    _vm.agentFilterState = $$v
                                  },
                                  expression: "agentFilterState",
                                },
                              }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "h__type",
                fn: function () {
                  return [
                    _c("div", { staticClass: "dropdown-filters-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$tc("global.words.type", 1)) +
                              "\n          "
                          ),
                          _c("icon", { attrs: { name: "filter" } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _c("generic-filter-dropdown-menu", {
                            attrs: {
                              "show-all-option": "",
                              options: _vm.reportTypesOptions,
                              "id-key": "types",
                            },
                            model: {
                              value: _vm.reportTypeFilterState,
                              callback: function ($$v) {
                                _vm.reportTypeFilterState = $$v
                              },
                              expression: "reportTypeFilterState",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "fullName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "profile-avatar",
                          _vm._b(
                            { staticClass: "client-avatar" },
                            "profile-avatar",
                            _vm.getRequesterAccountDetails(row),
                            false
                          )
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "mx-2" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("fullName")(
                                  _vm.getRequesterAccountDetails(row)
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "type",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t("application-reports." + row.type + ".name")
                        ) +
                        "\n    "
                    ),
                  ]
                },
              },
              {
                key: "format",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm._f("uppercase")(row.fileType)) +
                        "\n    "
                    ),
                  ]
                },
              },
              {
                key: "requestedAt",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("momentLocal")(
                            row.requestedAtTimestamp,
                            "MMMM D, YYYY LT"
                          )
                        ) +
                        "\n    "
                    ),
                  ]
                },
              },
              {
                key: "actions",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "b-row",
                      { staticClass: "align-items-center justify-content-end" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "d-none d-xl-block",
                            attrs: { cols: "auto" },
                          },
                          [
                            _c(
                              "simple-button",
                              {
                                attrs: {
                                  "class-name": "btn-sm",
                                  type: "secondary",
                                  loading:
                                    _vm.selectedReportId === row.id &&
                                    _vm.loadingPreviewState.loading,
                                  "loading-succeeded":
                                    _vm.selectedReportId === row.id &&
                                    _vm.loadingPreviewState.loadingSucceeded,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleViewReport(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-reports.history.viewReport"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "d-none d-xl-block",
                            attrs: { cols: "auto" },
                          },
                          [
                            _c(
                              "simple-button",
                              {
                                attrs: {
                                  "class-name": "btn-sm",
                                  type: "primary",
                                  loading: _vm.downloading === row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDownloadReport(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-reports.history.downloadReport"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex justify-content-end d-xl-none",
                            attrs: { cols: "10" },
                          },
                          [
                            _c(
                              "button-loader",
                              {
                                attrs: {
                                  loading:
                                    _vm.downloading === row.id ||
                                    _vm.selectedReportId === row.id,
                                  "show-custom-color": "",
                                },
                              },
                              [
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: {
                                      variant: "transparent",
                                      "toggle-class":
                                        "text-gray position-static bs-0",
                                      "no-caret": "",
                                      right: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("more_vert")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleViewReport(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-reports.history.viewReport"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDownloadReport(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-reports.history.downloadReport"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
      _vm._v(" "),
      _vm.fetchingTableData
        ? _c("div", [_c("report-history-table-row-loader")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c("document-preview-modal", {
        ref: "previewDocumentModal",
        attrs: {
          "file-name": _vm.selectedReportName,
          url: _vm.selectedReportFileUrl,
          "document-is-downloading": _vm.downloading === _vm.selectedReportId,
        },
        on: {
          "download-document": function ($event) {
            return _vm.handleDownloadReport(_vm.selectedReport)
          },
          hide: _vm.handleClosePreview,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }